import React, { FC } from 'react';

import Steps from '../steps/Steps';
import { useWizard, WizardStep } from '../../../contexts/WizardContext';


const Header: FC = (): JSX.Element => {

  const {
    changeStep,
  } = useWizard();

  return (
  <div className="header-container">
    <div className="header-logo">
      <img
        onClick={() => changeStep(WizardStep.HOME, false, true)}
        src={`${process.env.PUBLIC_URL}/assets/images/Logo_zota.png`} alt="logo"/>
    </div>
    <div className="header-steps">
      <Steps />
    </div>
  </div>
  )
};

export default Header;
